import { TimeUtils } from '@front/volcanion/utils'
import moment from 'moment'

class Callbacks {
  static onFilterChangeHandler(reset, reload, onSubmit) {
    return async function onFilterChange(filter) {
      await reset()
      await reload(filter)
    }
  }

  static handleActiveFilterHandler(onFilterChange) {
    return function handleActiveFilter() {
      return onFilterChange({
        quick: {
          status: ['standby', 'attributed']
        },
        transport: {
          assigned_transport: {
            status: ['started', 'at_src', 'on_board', 'at_dst', 'off_board']
          }
        }
      })
    }
  }

  static handleReservationFilterHandler(onFilterChange) {
    return function handleReservationFilter() {
      return onFilterChange({
        quick: {
          status: ['created', 'standby', 'attributed'],
          schedule_type: ['planned']
        }
      })
    }
  }

  static handleNotLoadedFilterHandler(onFilterChange, not_loaded_reason_id) {
    return function handleNotLoadedFilter() {
      return onFilterChange({
        quick: {
          status: ['canceled']
        },
        transport: {
          reason: [not_loaded_reason_id]
        }
      })
    }
  }

  static handleTodayFilterHandler(onFilterChange) {
    return function handleTodayFilter() {
      const now = moment()
      return onFilterChange({
        quick: {
          requestedAt: {
            start: TimeUtils.formatDateFrontToBack(now.startOf('day')),
            end: TimeUtils.formatDateFrontToBack(now.endOf('day'))
          }
        }
      })
    }
  }

  static handleTodayPlusOneFilterHandler(onFilterChange) {
    return function handleTodayPlusOneFilter() {
      const now = moment()
      return onFilterChange({
        quick: {
          requestedAt: {
            start: TimeUtils.formatDateFrontToBack(now.startOf('day')),
            end: TimeUtils.formatDateFrontToBack(now.endOf('day').add(1, 'day'))
          }
        }
      })
    }
  }

  static handleTodayPlusTwoFilterHandler(onFilterChange) {
    return function handleTodayPlusTwoFilter() {
      const now = moment()
      return onFilterChange({
        quick: {
          requestedAt: {
            start: TimeUtils.formatDateFrontToBack(now.startOf('day')),
            end: TimeUtils.formatDateFrontToBack(now.endOf('day').add(2, 'day'))
          }
        }
      })
    }
  }

  static handleTodayCreatedFilterHandler(onFilterChange) {
    return function handleTodayCreatedFilter() {
      const now = moment()
      return onFilterChange({
        quick: {
          requestedAt: {
            start: TimeUtils.formatDateFrontToBack(now.startOf('day')),
            end: TimeUtils.formatDateFrontToBack(now.endOf('day'))
          },
          status: ['created', 'standby']
        }
      })
    }
  }

  static handleTodayCanceledFilterHandler(onFilterChange) {
    return function handleTodayCanceledFilter() {
      const now = moment()
      return onFilterChange({
        quick: {
          requestedAt: {
            start: TimeUtils.formatDateFrontToBack(now.startOf('day')),
            end: TimeUtils.formatDateFrontToBack(now.endOf('day'))
          },
          status: ['canceled']
        }
      })
    }
  }

  static handleGreaterThanThreeFilterHandler(onFilterChange) {
    return function handleGreaterThanThreeFilter() {
      const now = moment()
      return onFilterChange({
        quick: {
          requestedAt: {
            start: TimeUtils.formatDateFrontToBack(now.startOf('day').add(3, 'day'))
          }
        }
      })
    }
  }

  static handleProvincesFilterHandler(onFilterChange, province_ids) {
    return function handleProvincesFilter() {
      return onFilterChange({
        quick: {
          city: province_ids
        }
      })
    }
  }

  static createFilterHandlerHandler(setActiveFilterKey) {
    return function createFilterHandler(filterKey, filterCallback) {
      return function onFilterClick() {
        setActiveFilterKey(filterKey)
        filterCallback()
      }
    }
  }

}

export default Callbacks
